import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@wit-support/ui';
import { pipelineRunStatusLabelRu, pipelineRunStatusVariant, pipelineStepStatusLabelRu, pipelineStepStatusVariant, } from './pipeline-labels.js';
/**
 * RUN-status badge. With no overrides it renders the canonical
 * `pipelineRunStatusLabelRu` / `pipelineRunStatusVariant` pair from
 * `./pipeline-labels.js` (RU capitalized phrase + tone, raw-value fallback for
 * an unknown status). Extracted from the conversation rail's `PipelineRunHistory`
 * — kit-extraction Wave 6, task 7. Both original call sites (the rail's
 * `PipelineRunHistory` and the pipeline-runs page) migrated onto this
 * component in Wave 7.
 */
export function PipelineRunStatusBadge({ status, size, labels, variants, }) {
    const label = labels ? (labels[status] ?? status) : pipelineRunStatusLabelRu(status);
    const variant = variants
        ? (variants[status] ?? 'neutral')
        : pipelineRunStatusVariant(status);
    return (_jsx(Badge, { variant: variant, size: size, children: label }));
}
PipelineRunStatusBadge.displayName = 'PipelineRunStatusBadge';
/**
 * STEP-status badge — same shape as {@link PipelineRunStatusBadge}, backed by
 * `pipelineStepStatusLabelRu` / `pipelineStepStatusVariant`. The `danger` tone
 * for every `PIPELINE_ERROR_STEP_STATUSES` entry is a compile-time invariant
 * enforced in `./pipeline-labels.js` itself, so both badges inherit it —
 * there is no second guard to keep in sync here.
 */
export function PipelineStepStatusBadge({ status, size, labels, variants, }) {
    const label = labels ? (labels[status] ?? status) : pipelineStepStatusLabelRu(status);
    const variant = variants
        ? (variants[status] ?? 'neutral')
        : pipelineStepStatusVariant(status);
    return (_jsx(Badge, { variant: variant, size: size, children: label }));
}
PipelineStepStatusBadge.displayName = 'PipelineStepStatusBadge';
//# sourceMappingURL=pipeline-status.js.map